
export const PublicSellerShopsQuery = new TypedDocumentString(`
    query PublicSellerShopsQuery($input: InputProductExtraShops!) {
  publicSellerShops(input: $input) {
    items {
      ...ProductExtraShop
      __typename
    }
    __typename
  }
}
    fragment DocumentColorHsla on DocumentColorHsla {
  h
  s
  l
  a
  __typename
}
fragment ImageNodeItem on ImageNodeItem {
  _id
  alt
  uploadDate
  type
  url
  fallbackUrl
  img
  height
  width
  noProxy
  hsla {
    ...DocumentColorHsla
    __typename
  }
  aspect {
    x
    y
    __typename
  }
  audio
  videoHls
  video
  isVideo
  __typename
}
fragment Image on Image {
  alt {
    value
    __typename
  }
  isVideo
  image2 {
    ...ImageNodeItem
    __typename
  }
  __typename
}
fragment ProductExtraShop on ProductExtraShop {
  id
  title {
    value
    __typename
  }
  image {
    ...Image
    __typename
  }
  address {
    value
    __typename
  }
  city {
    value
    __typename
  }
  contacts {
    ...SellerContacts
    __typename
  }
  document {
    _id
    __typename
  }
  __typename
}
fragment OpeningHoursHour on OpeningHoursHour {
  hour
  min
  __typename
}
fragment OpeningHoursDay on OpeningHoursDay {
  open24
  close
  hours {
    open {
      ...OpeningHoursHour
      __typename
    }
    close {
      ...OpeningHoursHour
      __typename
    }
    __typename
  }
  __typename
}
fragment SellerContacts on SellerContacts {
  emails
  tels
  openingHours {
    timezone
    mon {
      ...OpeningHoursDay
      __typename
    }
    tue {
      ...OpeningHoursDay
      __typename
    }
    wed {
      ...OpeningHoursDay
      __typename
    }
    thu {
      ...OpeningHoursDay
      __typename
    }
    fri {
      ...OpeningHoursDay
      __typename
    }
    sat {
      ...OpeningHoursDay
      __typename
    }
    sun {
      ...OpeningHoursDay
      __typename
    }
    __typename
  }
  links {
    type
    handle
    __typename
  }
  __typename
}`, {"hash":"d72158daa1cdf3e05caf574c1ac74cf9d3a3cea6ac6f7c3fd8c9bce4a266c979"});